<rlst-modal header="Customize Search" (closeModal)="close()">
  <div class="selection-header text-black">
    Please select recent saved search or create a new one:
    <rlst-action-dropdown defaultActionName="Create New Saved Search"
                          [itemList]="selectItemList"
                          (defaultAction)="createNewSearch()"
                          (itemAction)="confirmOpenSearch($event)"
                          [currentItem]="selectedEditSearch || {label: 'New Search'}"
                          class="dropdown">
    </rlst-action-dropdown>
    <p class="mb-0 pl-2 ml-auto text-right" *ngIf="selectedEditSearch?.modifiedDate"><span
      class="label">Date modified:</span>{{selectedEditSearch.modifiedDate | date: 'MM/dd/yyyy'}}</p>
  </div>
  <div [ngClass]="{'sub-header_hide': isMobileNextStep}" class="d-sm-flex d-block sub-header justify-content-between flex-column flex-md-row">
    <fieldset class="d-flex align-items-center edit-name">
      <button type="button" *ngIf="!isAdmin" class="btn-custom btn-small mr-1" (click)="editNameField.focus()">
        <i class="far fa-pencil" aria-hidden="true"></i>
        <span class="sr-only">Edit</span>
      </button>

      <div class="locked d-flex" *ngIf="isAdmin">
        <i class="far fa-lock" aria-hidden="true"></i>
        <span class="sr-only">Owned by Admin</span>
      </div>
      <div class="d-flex flex-column position-relative">
        <input #editNameField
               type="text"
               class="form-control"
               [ngClass]="{
                  'error': nameExist$ | async,
                  'error-empty': emptyName
                }"
               placeholder="Type Search Name*"
               [attr.maxlength]="maxNameLength"
               [formControl]="editNameControl">
        <span *ngIf="nameExist$ | async" class="position-absolute invalid-name">This name already exists. Saving will update the existing search</span>
      </div>
    </fieldset>

    <div [ngClass]="{'with-dividers': isAdmin}"
         class="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between justify-content-md-start">
      <ng-container *ngIf="!isAdmin">
        <form [formGroup]="mySearchType" class="d-flex my-search-type-form">
          <label class="custom-control custom-radio d-flex align-items-center"
                 [ngClass]="{'custom-control--disabled': mySearchType.get('searchType').disabled}">
            <input [value]="templateType.FORM"
                   formControlName="searchType"
                   tabindex="0"
                   type="radio"
                   class="custom-control-input radio-primary">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">
              <img src='assets/img/search/search_form.svg' alt="Only form">
              <span class="capitalize-first-letter left-6"><span class="d-none d-md-inline-block">Search</span> template</span>
            </span>
          </label>
          <label class="custom-control custom-radio d-flex align-items-center"
                 [ngClass]="{'custom-control--disabled': mySearchType.get('searchType').disabled}">
            <input [value]="templateType.SEARCH"
                   formControlName="searchType"
                   tabindex="0"
                   type="radio"
                   class="custom-control-input radio-primary">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">
              <img src='assets/img/search/search_with_values.svg' alt="Form with value">
              <span class="capitalize-first-letter left-6"><span class="d-none d-md-inline-block">Search</span> template with values</span>
            </span>
          </label>
        </form>
      </ng-container>
      <div class="d-flex justify-content-between m-width-100 date-modified-and-delete-search-container">
        <div *ngIf="isAdmin" class="mb-0 pt-0 pt-md-1">
          <span class="label">Type:</span>
          <span *ngIf="mySearchType.get('searchType').value === templateType.FORM; then templateOnly else templateWithValues"></span>
          <ng-template #templateOnly>
            <span class="capitalize-first-letter left-6"><span class="d-none d-md-inline-block">Search</span> template</span>
          </ng-template>
          <ng-template #templateWithValues>
            <span class="capitalize-first-letter left-6"><span class="d-none d-md-inline-block">Search</span> template with values</span>
          </ng-template>
        </div>
        <p class="mb-0 date-modified-mobile d-mobile" *ngIf="selectedEditSearch?.modifiedDate"><span
          class="label">Date modified:</span>{{selectedEditSearch.modifiedDate | date: 'MM/dd/yyyy'}}</p>
        <ng-container *ngIf="!isAdmin && selectedEditSearch && selectedEditSearch.templateCode">
          <span class="separator d-desktop">|</span>
          <div class="delete-search d-flex">
            <button type="button" class="btn btn-outline-dark btn-block btn-small" (click)="deleteSearch()">
              <i class="far fa-trash-alt" aria-hidden="true"></i> Delete Search
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="isAdmin" [ngClass]="{'sub-header_hide': isMobileNextStep}" class="sub-header mt-3 mt-md-0">
    <p class="pr-5 mb-0 admin-message">You are not able to make any changes to the search configured by Admin. <br>
      Adding more attributes to this search will automatically create a new search.</p>
  </div>
  <div class="content" [ngClass]="{'content_no-top-padding': isMobileNextStep}">
    <div class="mobile-back d-md-none d-flex justify-content-between" *ngIf="isMobileNextStep">
      <button class="btn btn-back p-0 w-auto" type="button" (click)="toggleMobileNextStep()">
        <i class="fa fa-angle-left" aria-hidden="true"></i>BACK
      </button>
    </div>
    <div class="d-flex flex-column">
      <rlst-categories-list [categories]="categories"
                            (categorySelection)="setCategory($event)"
                            [selectedCategory]="selectedCategory"
                            [isMobileNextStep]="isMobileNextStep"
                            headerTitle="Categories"
                            aggregateCategoryTitle="All Categories"
                            class="h-100">
      </rlst-categories-list>
    </div>
    <div class="attributes-selection flex-column w-100 pt-3 pt-md-0"
         [ngClass]="{'attributes-selection_hide': !isMobileNextStep}">
      <rlst-attributes-selection [isMobileNextStep]="isMobileNextStep"
                                 [attributes]="displayedAttributes"
                                 [maxNumber]="maxNumber"
                                 [selectedNumber]="selectedAttributes.length"
                                 class="h-100 w-100"
                                 headerTitle="Attributes Options"
                                 (attributeIsSelected)="selectAttribute($event)">
      </rlst-attributes-selection>
    </div>
    <div class="selected-properties flex-column h-100"
         [ngClass]="{'selected-properties_hide': isMobileNextStep}">
      <rlst-selected-properties (closeModal)="close()"
                                headerTitle="Selected Attributes"
                                nextStepButtonLabel="Add Attributes"
                                canGoNextStepOnDisabled="true"
                                class="selected-options h-100 d-flex"
                                [selectedItems]="selectedAttributes"
                                [isDisabled]="isAdmin"
                                [maxNumber]="maxNumber"
                                (toggleMobileNextStep)="toggleMobileNextStep()"
                                (clearSelection)="clearSelection()"
                                (itemRemoved)="removeAttribute($event)">
        <ng-template #selectedProperty let-item>
          <p class="current-item">{{ item.fieldLabel | rlstReplaceSymbols}}</p>
        </ng-template>
      </rlst-selected-properties>
    </div>
  </div>
  <div mat-dialog-actions class="actions-panel d-flex flex-nowrap">
    <div class="flex-spacer"></div>
    <button type="button" (click)="close()"
            class="btn-custom btn-custom-outline-blue-dark cancel-button d-none d-md-flex">Cancel
    </button>
    <button type="button" (click)="saveNewSearch()"
            class="btn-custom btn-custom-blue-dark justify-content-center ml-0 ml-md-3"
            [disabled]="isAdmin || !selectedAttributes.length">Save
    </button>
    <button type="button"
            (click)="applyMySearch()"
            class="btn-custom btn-custom-blue-dark" [disabled]="!selectedAttributes.length">Apply
    </button>
  </div>
</rlst-modal>
